import { render, staticRenderFns } from "./companyStatus.vue?vue&type=template&id=69b470fe&"
import script from "./companyStatus.vue?vue&type=script&lang=js&"
export * from "./companyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports